import React from 'react';
import { ArrowRight } from 'lucide-react';

const ITFAQ = ({
    title = "Frequently Asked Questions",
    faqs = []
}) => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6 max-w-4xl">
                <div className="max-w-3xl mx-auto text-center mb-16">
                    <h2 className="text-3xl md:text-3xl font-bold text-slate-900 syne mb-4">
                        {title}
                    </h2>
                    <p className="text-slate-500 text-sm md:text-base leading-relaxed">
                        Answers to typical questions concerning technical evaluation methods, vendor transitions, and SLA commitments.
                    </p>
                </div>
                <div className="space-y-4">
                    {faqs && faqs.map((faq, i) => (
                        <details key={i} className="group bg-slate-50 rounded-2xl overflow-hidden border border-slate-100">
                            <summary className="p-6 cursor-pointer font-bold text-slate-700 flex justify-between items-center list-none group-open:bg-blue-600 group-open:text-white transition-all">
                                {faq.question}
                                <ArrowRight className="group-open:rotate-90 transition-transform" />
                            </summary>
                            <div className="p-8 text-slate-500 leading-relaxed bg-white">
                                {faq.answer}
                            </div>
                        </details>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ITFAQ;